import axios from "axios";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const devuelveDependenciaConstultada = async () => {
  const client = axios.create({
    baseURL:
      process.env.REACT_APP_BASEURL +
      "dependencias",
  });

  try {
    // ========================================================
    // CONSULTAR BACKEND
    // ========================================================

   const tokenJWT = localStorage.getItem("tokenJWT");

if (!tokenJWT) {
  console.error("No existe tokenJWT en localStorage");
  return [];
}

const respuesta = await client.post(
  "/",
  {},
  {
    headers: {
      Authorization: `Bearer ${tokenJWT}`,
    },
  }
);

    console.log(
      "DEPENDENCIAS RECIBIDAS DEL BACK:",
      respuesta.data
    );

    if (
      !respuesta.data ||
      !Array.isArray(respuesta.data)
    ) {
      console.error(
        "El backend no devolvió un array de dependencias"
      );

      return [];
    }

    // ========================================================
    // TOMAMOS LOS OBJETOS COMPLETOS
    // ========================================================

    const datos = respuesta.data.map(
      (dependencia) => ({
        ...dependencia,

        // normalizamos el padre
        dependenciaPadreId:
          dependencia.dependenciaPadreId ===
            "" ||
          dependencia.dependenciaPadreId ===
            undefined ||
          dependencia.dependenciaPadreId ===
            null
            ? null
            : Number(
                dependencia.dependenciaPadreId
              ),
      })
    );

    // ========================================================
    // ORDENAR
    // ========================================================

    datos.sort((a, b) =>
      String(
        a.descripcion || ""
      ).localeCompare(
        String(
          b.descripcion || ""
        ),
        "es",
        {
          sensitivity: "base",
        }
      )
    );

    // ========================================================
    // GUARDAR TODO EL ARRAY COMPLETO
    // ========================================================

    localStorage.setItem(
      "dependencias",
      JSON.stringify(datos)
    );

    // ========================================================
    // MANTENER CANTIDAD EN COOKIE
    // POR COMPATIBILIDAD CON LO ANTERIOR
    // ========================================================

    cookies.set(
      "cantidadDependencias",
      datos.length,
      {
        path: "/",
      }
    );

    // ========================================================
    // MANTENER COOKIES VIEJAS TEMPORALMENTE
    // ========================================================

    for (
      let i = 0;
      i < datos.length;
      i++
    ) {
      cookies.set(
        "ID" + i,
        datos[i].id,
        {
          path: "/",
        }
      );

      cookies.set(
        "D" + i,
        datos[i].descripcion ?? "",
        {
          path: "/",
        }
      );

      cookies.set(
        "DP" + i,
        datos[i]
          .dependenciaPadreId ?? "",
        {
          path: "/",
        }
      );
    }

    console.log(
      "DEPENDENCIAS GUARDADAS COMPLETAS:",
      datos
    );

    return datos;
  } catch (error) {
    console.error(
      "Error cargando dependencias:",
      error
    );

    // ========================================================
    // SI FALLA EL BACK, INTENTAMOS RECUPERAR CACHE
    // ========================================================

    try {
      const guardadas =
        localStorage.getItem(
          "dependencias"
        );

      if (guardadas) {
        const datosGuardados =
          JSON.parse(guardadas);

        if (
          Array.isArray(
            datosGuardados
          )
        ) {
          console.log(
            "Dependencias recuperadas desde localStorage:",
            datosGuardados
          );

          return datosGuardados;
        }
      }
    } catch (errorStorage) {
      console.error(
        "Error recuperando dependencias de localStorage:",
        errorStorage
      );
    }

    return [];
  }
};

export default devuelveDependenciaConstultada;